export default {
    VERSION: process.env.VERSION || "unknown",
    DEV: process.env.DEV,
    CASB_API_URL: process.env.CASB_API_URL,
    OVERRIDE_EXPIRATION_DAYS: process.env.OVERRIDE_EXPIRATION_DAYS,
};
